import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useZonedTime } from "@/hooks/useZonedTime";
import { ERecountOutcome } from "@/queries/GetMessagingVoterCounts";
/**
 * When an event's voter counts were counted, and why they may be older:
 * counting a realm takes time, so it runs in the background (after each
 * save of the event's messaging configuration, regularly, and on Recount),
 * never while the page loads. A recount that took too long or failed
 * keeps the previous counts, and says so.
 */
export var MessagingVoterCountStatus = function (_a) {
    var status = _a.status, onRecount = _a.onRecount, recounting = _a.recounting;
    var t = useTranslation().t;
    var zonedTime = useZonedTime();
    if (!status)
        return null;
    var lines = [
        status.computed_at
            ? t("messaging.voterCount.countedAt", { time: zonedTime(status.computed_at) })
            : t("messaging.voterCount.never"),
    ];
    if (status.outcome === ERecountOutcome.TIMED_OUT) {
        lines.push(t("messaging.voterCount.timedOut"));
    }
    else if (status.outcome === ERecountOutcome.FAILED) {
        lines.push(t("messaging.voterCount.failed"));
    }
    if (status.outcome && status.outcome !== ERecountOutcome.COUNTED && status.computed_at) {
        lines.push(t("messaging.voterCount.previous"));
    }
    if (status.pending)
        lines.push(t("messaging.voterCount.pending"));
    return (_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }, children: [_jsx(Typography, { variant: "caption", role: "status", sx: { color: "text.secondary" }, children: lines.join(" ") }), onRecount ? (_jsx(Button, { size: "small", variant: "outlined", onClick: onRecount, disabled: status.pending || recounting, children: t("messaging.voterCount.recount") })) : null] }));
};
